import { ChatBlkPromptSource } from '../types';

export interface FormattedSourceInfo {
    sourceTitle: Array<string>;
    secondaryInfo: string;
}

export const getFormattedSourceInfo = (
    source: ChatBlkPromptSource
): FormattedSourceInfo => {
    if (source) {
        const { title, publicationTime, authors = [] } = source;

        const formattedPublicationTime = publicationTime
            ? new Intl.DateTimeFormat('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
              }).format(new Date(publicationTime))
            : '';
        let formattedAuthors = '';
        if (authors?.length) {
            formattedAuthors = `Author${authors?.length > 1 ? 's' : ''}: ${authors.join(', ')}${formattedPublicationTime ? ', ' : ''}`;
        }

        return {
            sourceTitle: title.split(/( \| .*)/),
            secondaryInfo: `${formattedAuthors}${formattedPublicationTime}`,
        };
    }
};
